import { BUILDER_LANDING_PROMO_TYPE } from '../constants';
import { IState } from '../store';
import { ICountrysideBuilderLandingPromoVillageData } from '../types';
import { isSuburbanOfferFromBuilder } from '../utils/suburban';

export function getCountrysideBuilderLandingPromoData(
  state: IState,
  villageId: number,
): ICountrysideBuilderLandingPromoVillageData | null {
  const { offer } = state.offerData;

  const experiment = state.experiments.find(e => e.name === 'countryside_builder_landing_promo');
  if (!experiment) { return null; }

  if (!state.countrysideBuilderLandingData || !isSuburbanOfferFromBuilder(offer) || offer.category !== 'landSale') {
    return null;
  }

  const { villageMapList, projectsBlocks } = state.countrysideBuilderLandingData;
  if (!Array.isArray(villageMapList)) { return null; }

  const villageData = villageMapList.find(village => village.villageIds.includes(villageId));
  if (!villageData) { return null; }

  const projectBlock = typeof villageData.projectsBlockId !== 'undefined'
    ? projectsBlocks[String(villageData.projectsBlockId)]
    : undefined;

  return {
    bannerLink: villageData.bannerLink,
    projectBlock,
    bannerType: BUILDER_LANDING_PROMO_TYPE[experiment.abGroup],
  };
}
